import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { editarUsuarioRevenda, obterUsuarioRevendaPorId } from "../services/api";
import CadastroRevendaUsuario from "./CadastroRevendaUsuario";

const EditarRevendaUsuario = ({ token }) => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const revendaId = searchParams.get("revendaId") || "";

  const [initialData, setInitialData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await obterUsuarioRevendaPorId(id, token);
        setInitialData(response.data);
      } catch (error) {
        console.error("Erro ao carregar os dados do usuário da revenda:", error);
      }
    };
    fetchData();
  }, [id, token]);

  const handleEditSubmit = async (data, token) => {
    await editarUsuarioRevenda(id, data, token);
  };

  if (!initialData) return <div>Carregando...</div>;

  return (
    <CadastroRevendaUsuario
      token={token}
      initialData={initialData}
      onSubmit={handleEditSubmit}
      isEdit={true}
      revendaIdFromQuery={revendaId}
    />
  );
};

export default EditarRevendaUsuario;
